import { createContext, useContext } from 'react'

// LCP-slot framework (task #88). CLIENT-SAFE — imports NOTHING manifest-backed.
//
// Carries the `src` of the page's LCP image (resolved server-side by
// lib/lcpImage.js and threaded through props) down the tree. The ONE <Img>
// component reads it and forces `priority` (eager + fetchpriority=high) when its
// own descriptor's src matches — so the first above-the-fold image is
// prioritized automatically for EVERY template, with no per-section edit.
//
// Only a plain string src crosses the boundary, and it is derived from the SAME
// SSR props on server and client, so it is hydration-safe (server HTML ===
// client render). A null value (text-only page / no hero) is a no-op.
export const LcpContext = createContext(null)

/**
 * The LCP image src for the current page, or null. Consumed by <Img> to decide
 * whether it is the LCP element and must render priority.
 * @returns {string|null}
 */
export function useLcpSrc() {
  return useContext(LcpContext)
}

export default LcpContext
